export default __webpack_public_path__ + "static/media/icons_instagram.04b43041.svg";